/**
* @module index
* @author: zhangyemei
* @description:
* @since: 2020-05-23 17:52:42
*/
import React, { Component } from 'react';
import { Decrypt, Encrypt } from '@/utils/encrypt.js';
import { Dropdown, Menu, Badge } from 'antd';
import { connect } from 'react-redux';
import QRCode from 'qrcode.react';
import LiveRoom from '../../../PersonalCenter/CourseCenter/Components/LiveRoom';
const {
  SubMenu
} = Menu;

const headBgUrl = require('@/statics/img/head_default.png');

import { Local } from '@/utils/local.js';
import { loginOut, CheckGlobalLogin } from '@/fetch/api/token.js';
import { goLogin } from '@/utils/login.js';
import history from '@/router/history';
import * as personalActions from '@/models/personal/actions';
import { bindActionCreators } from 'redux';
import './style.less';
import WebSocketProxy from '@/utils/webSocket';

class UserInfo extends Component {
  state = {
    // userId: (Local.get('userInfo') && JSON.parse(Decrypt(Local.get('userInfo'))).userId) ? Number(JSON.parse(Decrypt(Local.get('userInfo'))).userId) : null,
    // userId:null,
    baseUrl: window.location.origin,
    baseInfo: this.props.baseInfo,
    schoolList: this.props.schoolList,
    currentDomain: window.location.host.indexOf('localhost') == -1 ? window.location.origin : 'http://ryyzs.dev-s.yunduoketang.cn/'
  };

  componentDidMount() {// if (Local.get('userInfo')){
    //   let userInfo = JSON.parse(Decrypt(Local.get('userInfo')));
    // 	let userId = userInfo.userId ? userInfo.userId : null;
    // 	this.setState({ userId });
    // }
  } //退出登录


  logout = () => {
    loginOut().then(res => {
      this.props.personalActions.GetChangePasswordConfig(0);
      let url = '';
      if (res.loginSchoolPath) url = res.loginSchoolPath;
      window.location.href = `${window.location.origin}${url}`;
      this.clearSomeCache();
      WebSocketProxy.loginWebsocket('general', 'loginOut', 'login', 0);
    }).catch(err => Promise.reject(err));
  }; //注册（需要判断关闭了独立登陆页，useLoginPage是否使用登录页面 0否，1是）
  // toRegister = () => {
  //   let hash = '';
  //   if (window.location.hash.indexOf('?code=') > -1) {
  //     hash = `${window.location.pathname}${window.location.hash.split('?')[0]}`
  //   } else {
  //     hash = `${window.location.pathname}${window.location.hash}`
  //   }
  //   let queryString = window.encodeURIComponent(hash)
  //   // let baseInfo = this.state.baseInfo;
  //   // if (baseInfo && baseInfo.useLoginPage == 1) {
  //   //   window.location.href = `${window.location.origin}/registerPage`
  //   // }
  //   // let useLoginPage = Local.get('useLoginPage');
  //   let { currentDomain } = this.state
  //   CheckGlobalLogin({
  //     domain: currentDomain,
  //   }).then( res => {
  //       if( res.data === true){
  //           window.location.href = `${window.location.origin}/registerPage`
  //       }else {
  //           document.getElementById('loginRegisterBox').style.display = 'flex';
  //           document.getElementsByClassName('register-box')[0].style.display = 'block';
  //           document.getElementsByClassName('login-box')[0].style.display = 'none';
  //           document.getElementsByClassName('header-active')[1].classList.add('active');
  //           document.getElementsByClassName('header-active')[0].classList.remove('active');
  //           // window.location.href = `${window.location.origin}?popwin=regist&returnUrl=${queryString}`
  //       }
  //   })
  //   // this.clearSomeCache();
  // }
  //清空部分缓存

  clearSomeCache = () => {
    Local.remove('token');
    Local.remove('userInfo');
    Local.remove('schoolId');
    Local.remove('main_color');
    Local.remove('useLoginPage');
    Local.remove('indexShowFlag'); // Local.remove('refresh_token')
  };
  goToAppDown = () => {
    window.open(`${window.location.origin}${window.location.pathname}#/appload`);
  };

  render() {
    const {
      baseUrl
    } = this.state;
    let userId = null;

    if (Local.get('userInfo')) {
      let userInfo = JSON.parse(Decrypt(Local.get('userInfo')));
      userId = userInfo.userId ? userInfo.userId : null;
    } // console.log(JSON.parse(Decrypt(Local.get('userInfo'))),"999999999999999")


    const {
      appConfig,
      personConfigInfo,
      currentUserInfo,
      personal,
      unreadMessage,
      lateLearnShow,
      registerConfigFlag,
      learnData
    } = this.props; // console.log('personal----',personal)
    // console.log(Local.get('registerConfigFlag'),`111	Local.get('registerConfigFlag')`);
    //APP下载

    const appLoad = <div data-inspector-line="116" data-inspector-column="6" data-inspector-relative-path="src\\containers\\Layout\\Header\\UserInfo\\index.jsx" className="load-box">
        <div data-inspector-line="117" data-inspector-column="8" data-inspector-relative-path="src\\containers\\Layout\\Header\\UserInfo\\index.jsx" className="load-top">
          {appConfig.scanDownURL ? <img data-inspector-line="119" data-inspector-column="12" data-inspector-relative-path="src\\containers\\Layout\\Header\\UserInfo\\index.jsx" className="img-qrcode" src={appConfig.scanDownURL} alt="" /> : null}
          {appConfig.iosDownURL || appConfig.androidDownURL ? <div data-inspector-line="122" data-inspector-column="12" data-inspector-relative-path="src\\containers\\Layout\\Header\\UserInfo\\index.jsx" className="load-type">
              <p data-inspector-line="123" data-inspector-column="14" data-inspector-relative-path="src\\containers\\Layout\\Header\\UserInfo\\index.jsx">手机客户端下载</p>
              {appConfig.iosDownURL ? <p data-inspector-line="125" data-inspector-column="16" data-inspector-relative-path="src\\containers\\Layout\\Header\\UserInfo\\index.jsx">
                  <i data-inspector-line="126" data-inspector-column="18" data-inspector-relative-path="src\\containers\\Layout\\Header\\UserInfo\\index.jsx" className="iconfont iconpingguo"></i>
                  <a data-inspector-line="127" data-inspector-column="18" data-inspector-relative-path="src\\containers\\Layout\\Header\\UserInfo\\index.jsx" href={appConfig.iosDownURL} target="_blank">iphone下载</a>
                </p> : null}
              {appConfig.androidDownURL ? <p data-inspector-line="131" data-inspector-column="16" data-inspector-relative-path="src\\containers\\Layout\\Header\\UserInfo\\index.jsx">
                  <i data-inspector-line="132" data-inspector-column="18" data-inspector-relative-path="src\\containers\\Layout\\Header\\UserInfo\\index.jsx" className="iconfont iconanzhuo"></i>
                  <a data-inspector-line="133" data-inspector-column="18" data-inspector-relative-path="src\\containers\\Layout\\Header\\UserInfo\\index.jsx" href={appConfig.androidDownURL} target="_blank">安卓下载</a>
                </p> : null}
            </div> : null}
        </div>

        {appConfig.schoolURL ? <div data-inspector-line="141" data-inspector-column="10" data-inspector-relative-path="src\\containers\\Layout\\Header\\UserInfo\\index.jsx" className="load-bottom">
            <QRCode data-inspector-line="142" data-inspector-column="12" data-inspector-relative-path="src\\containers\\Layout\\Header\\UserInfo\\index.jsx" className="img-qrcode" size={112} fgColor="#000000" value={appConfig.schoolURL} />
            <div data-inspector-line="148" data-inspector-column="12" data-inspector-relative-path="src\\containers\\Layout\\Header\\UserInfo\\index.jsx">打开APP，扫描网校二维码进入学习</div>
          </div> : null}
      </div>; //用户头像

    const headPic = currentUserInfo && currentUserInfo.headPicMax ? currentUserInfo.headPicMax : currentUserInfo && currentUserInfo.headPicMax ? currentUserInfo.headPicMax : headBgUrl; //用户信息

    const userInfo = currentUserInfo && <Menu data-inspector-line="162" data-inspector-column="6" data-inspector-relative-path="src\\containers\\Layout\\Header\\UserInfo\\index.jsx" className={'layout-user-info'}>
        <div data-inspector-line="163" data-inspector-column="8" data-inspector-relative-path="src\\containers\\Layout\\Header\\UserInfo\\index.jsx" className="userinfo-box">
          <div data-inspector-line="164" data-inspector-column="10" data-inspector-relative-path="src\\containers\\Layout\\Header\\UserInfo\\index.jsx" className="box-top">
            <img data-inspector-line="165" data-inspector-column="12" data-inspector-relative-path="src\\containers\\Layout\\Header\\UserInfo\\index.jsx" className="head-pic" src={headPic} alt="" />
            <div data-inspector-line="166" data-inspector-column="12" data-inspector-relative-path="src\\containers\\Layout\\Header\\UserInfo\\index.jsx" className="user">
              <React.Fragment>
                <span data-inspector-line="168" data-inspector-column="16" data-inspector-relative-path="src\\containers\\Layout\\Header\\UserInfo\\index.jsx" className="username">
                  {currentUserInfo.nickName || currentUserInfo.mobile || currentUserInfo.username && currentUserInfo.username.substr(0, 12) || currentUserInfo.email || ''}
                </span>

                {
                /* 会员图标根据后台配置显示 */
              }
                {currentUserInfo.memberFlag == 1 ? <img data-inspector-line="174" data-inspector-column="18" data-inspector-relative-path="src\\containers\\Layout\\Header\\UserInfo\\index.jsx" className="level" src={currentUserInfo.memberIco} alt="" onClick={() => {
                history.push("/personal/accountcenter/account/member");
              }} /> : null}
              </React.Fragment>

              {
              /* 积分根据后台配置显示 */
            }
              {personal.serviceConfig.openIntegral == 1 ? <div data-inspector-line="185" data-inspector-column="16" data-inspector-relative-path="src\\containers\\Layout\\Header\\UserInfo\\index.jsx" className="member">
                  <a data-inspector-line="186" data-inspector-column="18" data-inspector-relative-path="src\\containers\\Layout\\Header\\UserInfo\\index.jsx" className="change-font-hover" href={`${baseUrl}${process.env.REACT_APP_PATH}/#/personal/accountcenter/score`}>
                    <span data-inspector-line="187" data-inspector-column="20" data-inspector-relative-path="src\\containers\\Layout\\Header\\UserInfo\\index.jsx">{currentUserInfo.integralName || '积分'}&nbsp;<em data-inspector-line="187" data-inspector-column="70" data-inspector-relative-path="src\\containers\\Layout\\Header\\UserInfo\\index.jsx">{currentUserInfo.integralRemaining || 0}</em></span>
                  </a>
                </div> : null}
            </div>
          </div>

          <div data-inspector-line="194" data-inspector-column="10" data-inspector-relative-path="src\\containers\\Layout\\Header\\UserInfo\\index.jsx" className="box-center">
            <div data-inspector-line="195" data-inspector-column="12" data-inspector-relative-path="src\\containers\\Layout\\Header\\UserInfo\\index.jsx">
              <div data-inspector-line="196" data-inspector-column="14" data-inspector-relative-path="src\\containers\\Layout\\Header\\UserInfo\\index.jsx">
                <i data-inspector-line="197" data-inspector-column="16" data-inspector-relative-path="src\\containers\\Layout\\Header\\UserInfo\\index.jsx" className="iconfont iconkecheng"></i>
                <a data-inspector-line="198" data-inspector-column="16" data-inspector-relative-path="src\\containers\\Layout\\Header\\UserInfo\\index.jsx" href={`${baseUrl}${process.env.REACT_APP_PATH}/#/personal/course/classTable?parentId=-1`}>课程中心</a>
              </div>
              <div data-inspector-line="200" data-inspector-column="14" data-inspector-relative-path="src\\containers\\Layout\\Header\\UserInfo\\index.jsx">
                <i data-inspector-line="201" data-inspector-column="16" data-inspector-relative-path="src\\containers\\Layout\\Header\\UserInfo\\index.jsx" className="iconfont iconshezhi"></i>
                <a data-inspector-line="202" data-inspector-column="16" data-inspector-relative-path="src\\containers\\Layout\\Header\\UserInfo\\index.jsx" href={`${baseUrl}${process.env.REACT_APP_PATH}/#/personal/setting/account?parentId=-1`}>个人设置</a>
              </div>
            </div>
            <div data-inspector-line="205" data-inspector-column="12" data-inspector-relative-path="src\\containers\\Layout\\Header\\UserInfo\\index.jsx">
              {
              /* <div>
               <i className="iconfont icondingdan"></i>
               <a href={`${baseUrl}${process.env.REACT_APP_PATH}/#/personal/order?parentId=-1`}>订单管理</a>
              </div> */
            }
              <div data-inspector-line="210" data-inspector-column="14" data-inspector-relative-path="src\\containers\\Layout\\Header\\UserInfo\\index.jsx">
                <i data-inspector-line="211" data-inspector-column="16" data-inspector-relative-path="src\\containers\\Layout\\Header\\UserInfo\\index.jsx" className="iconfont iconxiaoxi1"></i>
                <a data-inspector-line="212" data-inspector-column="16" data-inspector-relative-path="src\\containers\\Layout\\Header\\UserInfo\\index.jsx" href={`${baseUrl}${process.env.REACT_APP_PATH}/#/personal/message/detailslist?parentId=-1`}>
                  我的消息<Badge data-inspector-line="213" data-inspector-column="22" data-inspector-relative-path="src\\containers\\Layout\\Header\\UserInfo\\index.jsx" dot={unreadMessage > 0 ? true : false} />
                </a>
              </div>
            </div>
          </div>

          {
          /* 最近学习记录 */
        }
          {lateLearnShow && <div data-inspector-line="220" data-inspector-column="28" data-inspector-relative-path="src\\containers\\Layout\\Header\\UserInfo\\index.jsx" className="box-message">
            <p data-inspector-line="221" data-inspector-column="12" data-inspector-relative-path="src\\containers\\Layout\\Header\\UserInfo\\index.jsx" onClick={() => this.liveRoom.goDetail(learnData)}><i data-inspector-line="221" data-inspector-column="65" data-inspector-relative-path="src\\containers\\Layout\\Header\\UserInfo\\index.jsx" className="iconfont iconshijian" style={{
              fontSize: '18px'
            }}></i>{learnData.courseName}</p>
            <p data-inspector-line="222" data-inspector-column="12" data-inspector-relative-path="src\\containers\\Layout\\Header\\UserInfo\\index.jsx">
              <span data-inspector-line="223" data-inspector-column="14" data-inspector-relative-path="src\\containers\\Layout\\Header\\UserInfo\\index.jsx" className="ellipsis" onClick={() => this.liveRoom.goDetail(learnData)}>{learnData.lessonName}</span>
              <span data-inspector-line="224" data-inspector-column="14" data-inspector-relative-path="src\\containers\\Layout\\Header\\UserInfo\\index.jsx" className="continue" onClick={() => this.liveRoom.goDetail(learnData)}>继续</span>
            </p>
          </div>}

          <LiveRoom data-inspector-line="229" data-inspector-column="10" data-inspector-relative-path="src\\containers\\Layout\\Header\\UserInfo\\index.jsx" onRef={ref => this.liveRoom = ref} />
          <div data-inspector-line="230" data-inspector-column="10" data-inspector-relative-path="src\\containers\\Layout\\Header\\UserInfo\\index.jsx" className="box-bottom">
            {personConfigInfo.includes('USER_LOGOUT') && <a data-inspector-line="232" data-inspector-column="14" data-inspector-relative-path="src\\containers\\Layout\\Header\\UserInfo\\index.jsx" className="logout fr change-font-hover" onClick={this.logout}>退出登录</a>}
          </div>
        </div>
      </Menu>;
    return <React.Fragment>
        {//APP下载
      personConfigInfo.includes('HEAD_APP') && appConfig && appConfig.appConfigStatus ? <Dropdown data-inspector-line="244" data-inspector-column="12" data-inspector-relative-path="src\\containers\\Layout\\Header\\UserInfo\\index.jsx" className="user-info" overlay={appLoad}>
              <div data-inspector-line="245" data-inspector-column="14" data-inspector-relative-path="src\\containers\\Layout\\Header\\UserInfo\\index.jsx" style={{
          cursor: 'pointer'
        }} onClick={this.goToAppDown}><i data-inspector-line="245" data-inspector-column="76" data-inspector-relative-path="src\\containers\\Layout\\Header\\UserInfo\\index.jsx" className="iconfont iconshouji">&nbsp;</i>APP下载</div>
            </Dropdown> : null}


        {//我的消息
      userId && currentUserInfo ? <div data-inspector-line="252" data-inspector-column="12" data-inspector-relative-path="src\\containers\\Layout\\Header\\UserInfo\\index.jsx" className="list-item message" onClick={() => {
        history.push("/personal/message/detailslist");
      }}>
              <span data-inspector-line="253" data-inspector-column="14" data-inspector-relative-path="src\\containers\\Layout\\Header\\UserInfo\\index.jsx">
                <i data-inspector-line="254" data-inspector-column="16" data-inspector-relative-path="src\\containers\\Layout\\Header\\UserInfo\\index.jsx" className="iconfont iconxiaoxi"></i>
                {currentUserInfo && currentUserInfo.unReadNum > 0 && // <span className={`unread-num ${Local.get('main_color') == 'red' ? 'red' : ''}`}>{currentUserInfo.unReadNum}</span>
          <Badge data-inspector-line="257" data-inspector-column="18" data-inspector-relative-path="src\\containers\\Layout\\Header\\UserInfo\\index.jsx" dot={true} />}
              </span>
            </div> : null}

        {//个人中心（需要判断用户是否登录）
      userId ? currentUserInfo && <Dropdown data-inspector-line="265" data-inspector-column="12" data-inspector-relative-path="src\\containers\\Layout\\Header\\UserInfo\\index.jsx" className="user-info" overlay={userInfo}>
              <div data-inspector-line="266" data-inspector-column="14" data-inspector-relative-path="src\\containers\\Layout\\Header\\UserInfo\\index.jsx">
                <a data-inspector-line="267" data-inspector-column="16" data-inspector-relative-path="src\\containers\\Layout\\Header\\UserInfo\\index.jsx" href={`${baseUrl}/s/pc/#/personal/course/classTable?parentId=-1`} onClick={this.props.changeMenu}>
                  <img data-inspector-line="268" data-inspector-column="18" data-inspector-relative-path="src\\containers\\Layout\\Header\\UserInfo\\index.jsx" className="head-pic fr" src={headPic} alt="" />
                </a>
              </div>
            </Dropdown> : <div data-inspector-line="272" data-inspector-column="12" data-inspector-relative-path="src\\containers\\Layout\\Header\\UserInfo\\index.jsx" className="no-login">
              {Local.get('registerConfigFlag') != 1 ? <a data-inspector-line="273" data-inspector-column="54" data-inspector-relative-path="src\\containers\\Layout\\Header\\UserInfo\\index.jsx" onClick={() => goLogin('register', 'loginViewBtn')}>注册</a> : null}
              {personConfigInfo.includes('USER_LOGIN') && registerConfigFlag != 1 && <span data-inspector-line="274" data-inspector-column="85" data-inspector-relative-path="src\\containers\\Layout\\Header\\UserInfo\\index.jsx" className="divider">|</span>}
              {personConfigInfo.includes('USER_LOGIN') && <a data-inspector-line="275" data-inspector-column="58" data-inspector-relative-path="src\\containers\\Layout\\Header\\UserInfo\\index.jsx" onClick={() => goLogin('login', 'loginViewBtn')}>登录</a>}
            </div>}
      </React.Fragment>;
  }

}

function mapStateToProps(state) {
  return {
    layout: state.layout,
    currentUserInfo: state.layout.currentUserInfo
  };
}

function mapDispatchToProps(dispatch) {
  return {
    personalActions: bindActionCreators(personalActions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(UserInfo);